/**
 * @file products-empty.tsx
 * @description Тексты пустого реестра товаров (phase19.31, разбор B §3 (а)):
 * товаров нет вовсе и «под эти условия товаров нет» со сбросом.
 */

import { Package, Plus, Search } from "lucide-react";
import { Link } from "react-router";

import { Button } from "../../ui/button";
import type { ListEmptySpec, ListFilteredEmptySpec } from "../../ui/responsive-list-types";

export function productsEmptySpec(newProductHref: string): ListEmptySpec {
  return {
    icon: Package,
    title: "В магазине пока нет товаров",
    description: "Добавьте первый — он появится на сайте после публикации",
    action: (
      <Button variant="outline" asChild>
        <Link to={newProductHref}>
          <Plus className="size-4" />
          Товар
        </Link>
      </Button>
    ),
  };
}

export function productsFilteredSpec(onReset: () => void): ListFilteredEmptySpec {
  return { icon: Search, title: "Под эти условия товаров нет", onReset };
}
